import { NSARouterMakerResult } from 'namirasoft-account-react';
import { LogLayout } from '../LogLayout';
import { LogEntities } from '../LogEntities';
import { LogProps } from '../LogProps';
import { useParams } from 'react-router-dom';
import ConsoleView from './ConsoleView';

interface LogListPageProps extends NSARouterMakerResult, LogProps
{
}

function LogListPage(props: LogListPageProps) 
{
	let { log_group_id } = useParams();

	if (!log_group_id)
		return <></>;
	return (
		<LogLayout {...props}
			action={{
				title: "",
				description: "This section displays the actual logs collected across your Log Groups. You can review log entries, and inspect messages to investigate events or debug system behavior.",
				menus: {}
			}}
			pages={{
				entity: LogEntities.log(props, log_group_id),
				list: {
					ui: {
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						},
						modes: {
							Console: {
								show_search: true,
								getChild: (entity, options) =>
								{
									return <ConsoleView
										{...props}
										entity={entity}
										filters={options.filters}
									></ConsoleView>;
								}
							}
						},
						default_mode: "Console"
					},
				},
				ui: {
					action: {
						menus: {
							view_history: false
						}
					}
				}
			}}
		>
			<></>
		</LogLayout >
	);
}

export default LogListPage;